
import React from 'react';

function GoogleMaps() {
  return (
    <iframe
      title="Google Maps"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.6150210841615!2d72.8147458!3d19.4290329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7a9b90aa1c96b%3A0x7d0a61d4c00d166f!2sScience%20Academy!5e0!3m2!1sen!2sin!4v1694336956087!5m2!1sen!2sin"
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
}

export default GoogleMaps;

